export default function mapOptionDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: true,
		templateUrl: "./components/map-option/map-option-template.html",
		scope: {
			heading: "@",
			optionValue: "="
		}
	};
}
